import { wrapper, createApiClient, Result, ApiError } from "../base";
import AnnotatedEventCategoryDO = App.Data.AnnotatedEventCategoryDO;

const basePath = `annotated-event-categories`;
const baseClient = createApiClient();

export default class {
	get(): Promise<Result<AnnotatedEventCategoryDO[], ApiError>> {
		return wrapper(baseClient.get(`${basePath}`));
	}

	create(
		category: AnnotatedEventCategoryDO
	): Promise<Result<AnnotatedEventCategoryDO, ApiError>> {
		return wrapper(baseClient.post(`${basePath}`, category));
	}

	update(
		category: AnnotatedEventCategoryDO
	): Promise<Result<AnnotatedEventCategoryDO, ApiError>> {
		return wrapper(baseClient.patch(`${basePath}/${category.id}`, category));
	}

	delete(id: number): Promise<Result<boolean, ApiError>> {
		return wrapper(baseClient.delete(`${basePath}/${id}`));
	}
}
